module.exports = "/_next/static/images/icon-check-07d0d9e8.png";